const createNewsItemBtn = (newsItem) => {
    const titleLink = newsItem.find('.news-item-link-img').attr('href')
    return `<div class="news-item-btn"><a href="${ titleLink }">Prohlédnout</a></div>`
}

function processNewsItem(newsItem) {
    if ($(newsItem).hasClass('rendered')) return
    $(createNewsItemBtn(newsItem)).insertAfter(newsItem.find('.description'))
    const contentElements = newsItem.children().not('.news-item-link-img')
    const contentWrapper = $('<div class="news-item-content"></div>')
    contentElements.wrapAll(contentWrapper)
    $(newsItem).addClass('rendered')
}

// Update image sources
function updateImageSources(item) {
    const img = item.find('img')
    const src = img.attr('src')
    const dataSrc = img.attr('data-src')

    if (src !== dataSrc) {
        img.attr('src', dataSrc)
    }
}

function addArticleDate() {
    const publishedTime = $('meta[property="article:published_time"]').attr('content');

    if (publishedTime) {
        $('.news-item-detail article header h1').after('<span class="article-time"></span>');
        $('.article-time').text(publishedTime);
    }
}


function addArticleBanner() {
    const productsBanner = $('.help-banner');
    const contentWrapper = $('#content-wrapper');
    const bannerTitle = $('.homepage-group-title.homepage-products-heading-2.h4')

    if (productsBanner.length && contentWrapper.length) {
        const container = $('<div class="container"></div>');
        container.append(productsBanner);
        contentWrapper.after(container);
        bannerTitle.html('<strong>Vyberte si</strong> ten pravý pro vás');
    }
}

export function typePost() {
    const typePost = $('.type-post')
    const backBtn = $('<a href="/realizace" class="btn btn-primary">Zpět na realizace</a>');
    const footer = $('article > footer');

    if (!typePost.length) return

    if (footer.length) {
        footer.prepend(backBtn);
    }

    addArticleDate()
    addArticleBanner()
}

export function typePostsBlog() {
    const typePost = $('.type-posts-listing')

    if (!typePost.length) return

    $('.news-wrapper .news-item').each(function () {
        const newsItem = $(this)
        processNewsItem(newsItem)
        updateImageSources(newsItem)
    })
}

export function addHpBlog(numItems = 2) {
    if (!$('.type-index').length) return

    $.get('/blog', function (blogContent) {
        const newsItems = $(blogContent).find('.news-item').slice(0, numItems).clone()

        if (!newsItems.length) return

        newsItems.each(function () {
            const newsItem = $(this)
            processNewsItem(newsItem)
            updateImageSources(newsItem)
        })

        const newsItemsHTML = newsItems
            .map((_, item) => item.outerHTML)
            .get()
            .join(' ')

        const blogContainer = $(/* HTML */ `
            <div id="blog-hp" class="container content-wrapper">
                <div class="blog-wrapper">
                    <div class="blog-title">
                        <div class="page-title-separator"></div>
                        <h4 class="homepage-group-title"><div>Aktuálně</div></h4>
                        <div class="news-wrapper">${ newsItemsHTML }</div>
                        <div class="news-btn-wrapper text-center">
                            <a href="/blog" class="btn btn-primary">Zobrazit více </a>
                        </div>
                    </div>
                </div>
            </div>
        `)

        blogContainer.insertAfter('#content-wrapper')
    })
}
